import React from "react";

import { DeleteButton } from "../../../../components/form-controls/button/delete-button/delete-button.component";
import { ProductHistory } from "../../../product-history/components/product-history.component";
import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";

import { ProductsTableControl } from "../products-table-control/products-table-control.component";

import { Content } from "./products-table-controls-column.styles";
import { ProductsTableControlsColumnProps } from "./products-table-controls-column.props";

export const ProductsTableControlsColumn = (props: ProductsTableControlsColumnProps) => (
  <ResponsiveTableCell className="wide" align="right">
    <Content>
      <ProductsTableControl showIf={!!props.resourceId && !!props.resourceType}>
        <ProductHistory
          buttonSize="small"
          resourceId={props.resourceId!}
          resourceType={props.resourceType!}
          useIcon={true}
          useIconOnly={true}
        />
      </ProductsTableControl>
      <ProductsTableControl>
        <DeleteButton
          onClick={props.onRemoveProduct}
          disabled={props.disabled}
          title={props.title}
        />
      </ProductsTableControl>
    </Content>
  </ResponsiveTableCell>
);
